import { trackEventMixpanel } from 'utils/mixpanel';

/** CSV spec: `module` is a fe_constant, fixed to "tpogen" for every TPOGen trigger. */
const TPOGEN_MODULE = 'tpogen';

/** Canonical `page_name` values for TPOGen surfaces, per mixpanelTriggers.csv "derived: from current route/page context". */
export const TPOGEN_PAGE_NAMES = {
    PLANS_LIST: 'plans_list',
    PLAN_DETAIL: 'plan_detail',
    PLAN_DETAIL_CALENDAR: 'plan_detail_calendar',
    PLAN_DETAIL_EVENTS: 'plan_detail_events',
    PLAN_DETAIL_PROMO: 'plan_detail_promo',
    PLAN_DETAIL_METRICS: 'plan_detail_metrics',
    PROMO_LIBRARY: 'promo_library',
    SCENARIO_COMPARISON: 'scenario_comparison',
} as const;

export type TpoGenPageName = (typeof TPOGEN_PAGE_NAMES)[keyof typeof TPOGEN_PAGE_NAMES];

type TrackTpoGenEventOptions = {
    keepalive?: boolean;
};

/**
 * Wraps trackEventMixpanel for TPOGen triggers, auto-attaching the standard
 * `module`/`page_name` properties documented in mixpanelTriggers.csv so call
 * sites only need to pass event-specific properties.
 */
export const trackTpoGenEvent = (
    eventName: string,
    pageName: TpoGenPageName,
    eventProperties: Record<string, unknown> = {},
    options?: TrackTpoGenEventOptions,
): void => {
    trackEventMixpanel(
        eventName,
        {
            module: TPOGEN_MODULE,
            page_name: pageName,
            ...eventProperties,
        },
        options,
    );
};
